export const ASSIGN_RESERVATIONS = "ASSIGN_RESERVATIONS";
export const ASSIGN_FIRST_RESERVATIONS_OF_DAY = "ASSIGN_FIRST_RESERVATIONS_OF_DAY";
export const ASSIGN_RESERVATIONS_BY_ROOM = "ASSIGN_RESERVATION_BY_ROOM";
export const ASSIGN_RESERVATION = "ASSIGN_RESERVATION";

export const ASSIGN_USERS = "ASSIGN_USERS";
export const ASSIGN_USER = "ASSIGN_USER";
export const ASSIGN_USER_KARTES = "ASSIGN_USER_KARTES";
export const ASSIGN_USER_ANYTIME_CONSULTATIONS = "ASSIGN_USER_ANYTIME_CONSULTATIONS";

export const ASSIGN_CHILD = "ASSIGN_CHILD";

export const ASSIGN_KARTES = "ASSIGN_KARTES";
export const ASSIGN_SIBLING_KARTES = "ASSIGN_SIBLING_KARTES";
export const ASSIGN_KARTE = "ASSIGN_KARTE";
export const ASSIGN_KARTE_IMAGE_LIST = "ASSIGN_KARTE_IMAGE_LIST";
export const ASSIGN_KARTE_IMAGE_LIST_REQUEST = "ASSIGN_KARTE_IMAGE_LIST_REQUEST";
export const ASSIGN_KARTE_REFERENCE_INFO = "ASSIGN_KARTE_REFERENCE_INFO";
export const ASSIGN_KARTE_MEDIA_FILE = "ASSIGN_KARTE_MEDIA_FILE";

export const ASSIGN_SHIFTS = "ASSIGN_SHIFTS";

export const ASSIGN_DOCTORS = "ASSIGN_DOCTORS";
export const ASSIGN_DOCTORS_BY_DEPARTMENT_TYPE = "ASSIGN_DOCTORS_BY_DEPARTMENT_TYPE";

export const ASSIGN_LOGIN_ACTION = "ASSIGN_LOGIN_ACTION";
export const ASSIGN_LOGGED_IN = "ASSIGN_LOGGED_IN";
export const ASSIGN_CURRENT_DOCTOR = "ASSIGN_CURRENT_DOCTOR";
export const EMAIL_LOGIN_ENABLED = "EMAIL_LOGIN_ENABLED";

export const ASSIGN_RELOAD_TIMEOUT_ID = "ASSIGN_RELOAD_TIMEOUT_ID";
export const ASSIGN_RESERVATION_TIMEOUT_ID = "ASSIGN_RESERVATION_TIMEOUT_ID";
export const ASSIGN_PERIOD_LIST_TIMEOUT_ID = "ASSIGN_PERIOD_LIST_TIMEOUT_ID";

export const ASSIGN_AUTHZ_SNACKBAR_VISIBLE = "ASSIGN_AUTHZ_SNACKBAR_VISIBLE";
export const ASSIGN_AUTHZ_SNACKBAR_MESSAGE = "ASSIGN_AUTHZ_SNACKBAR_MESSAGE";

export const ASSIGN_ANYTIME_CONSULTATIONS = "ASSIGN_ANYTIME_CONSULTATIONS";
export const APPEND_ANYTIME_CONSULTATIONS = "APPEND_ANYTIME_CONSULTATIONS";
export const RESET_ANYTIME_CONSULTATIONS = "RESET_ANYTIME_CONSULTATIONS";
export const ASSIGN_ANYTIME_CONSULTATION = "ASSIGN_ANYTIME_CONSULTATION";
export const ASSIGN_ANYTIME_CONSULTATION_ANSWER = "ASSIGN_ANYTIME_CONSULTATION_ANSWER";
export const SET_ANYTIME_CONSULTATION_ANSWER_CONTENT = "SET_ANYTIME_CONSULTATION_ANSWER_CONTENT";
export const ASSIGN_ANYTIME_CONSULTATION_KARTES = "ASSIGN_ANYTIME_CONSULTATION_KARTES";
export const ASSIGN_ANYTIME_CONSULTATION_SIBLING_KARTES = "ASSIGN_ANYTIME_CONSULTATION_SIBLING_KARTES";
export const ASSIGN_SEARCH_PARAMS = "ASSIGN_SEARCH_PARAMS";
export const ASSIGN_ANYTIME_CONSULTATION_REFERENCE_INFO = "ASSIGN_ANYTIME_CONSULTATION_REFERENCE_INFO";
export const ASSIGN_ANYTIME_CONSULTATION_SEARCH_KEYS = "ASSIGN_ANYTIME_CONSULTATION_SEARCH_KEYS";
export const ASSIGN_ANYTIME_CONSULTATION_FILTERED_FLAG = "ASSIGN_ANYTIME_CONSULTATION_FILTERED_FLAG";
export const ASSIGN_ELASTICSEARCH_ERROR_DETAIL = "ASSIGN_ELASTICSEARCH_ERROR_DETAIL";
export const ASSIGN_ANYTIME_CONSULTATION_ANSWER_POPUP_MESSAGE = "ASSIGN_ANYTIME_CONSULTATION_ANSWER_POPUP_MESSAGE";

export const ASSIGN_CONSULTATION_PREPROCESSING_REQUEST = "ASSIGN_CONSULTATION_PREPROCESSING_REQUEST";
export const ASSIGN_CONSULTATION_PREPROCESSING_STATUS = "ASSIGN_CONSULTATION_PREPROCESSING_STATUS";
export const RESET_CONSULTATION_PREPROCESSING_REQUEST = "RESET_CONSULTATION_PREPROCESSING_REQUEST";

export const KARTE_UPDATE_RESULT = "KARTE_UPDATE_RESULT";

export const SHIFTS_UPDATE_ERROR_DETAIL = "SHIFTS_UPDATE_ERROR_DETAIL";
export const SHIFTS_UPDATE_SKIPPINGS = "SHIFTS_UPDATE_SKIPPINGS";

export const ASSIGN_RECOMMEND_JOURNALS = "ASSIGN_RECOMMEND_JOURNALS";

export const ASSIGN_JOURNALS = "ASSIGN_JOURNALS";
export const ASSIGN_JOURNAL_ELASTICSEARCH_ERROR_DETAIL = "ASSIGN_JOURNAL_ELASTICSEARCH_ERROR_DETAIL";
export const ASSIGN_IS_JOURNAL_SEARCHING = "ASSIGN_IS_JOURNAL_SEARCHING";
export const ASSIGN_PREVIOUS_QUERY = "ASSIGN_PREVIOUS_QUERY";

export const ASSIGN_EPDS_ANSWER_LIST = "ASSIGN_EPDS_ANSWER_LIST";
export const ASSIGN_EPDS_ANSWER = "ASSIGN_EPDS_ANSWER";
export const ASSIGN_EPDS_URL = "ASSIGN_EPDS_URL";

export const ASSIGN_CHAT_LOGS = "CHAT_LOGS";
export const ADD_CHAT_LOG = "ADD_CHAT_LOG";

export const ASSIGN_ROOM = "ASSIGN_ROOM";

export const ASSIGN_ASSIGNED_ADVICE_SHEETS = "ASSIGN_ASSIGNED_ADVICE_SHEETS";
export const ASSIGN_DAYTIME_ADVICE_SHEET = "ASSIGN_DAYTIME_ADVICE_SHEET";
export const ASSIGN_ACTIVE_DOCTORS_WITH_SHEETS = "ASSIGN_ACTIVE_DOCTORS_WITH_SHEETS";
export const ASSIGN_DAYTIME_ADVICE_REFERENCE_INFO = "ASSIGN_DAYTIME_ADVICE_REFERENCE_INFO";
export const ASSIGN_DAYTIME_ADVICE_TODAYS_POOLING_COUNT = "ASSIGN_DAYTIME_ADVICE_TODAYS_POOLING_COUNT";
export const ASSIGN_USER_DAYTIME_ADVICE_SHEETS = "ASSIGN_USER_DAYTIME_ADVICE_SHEETS";
export const ASSIGN_DAYTIME_ADVICE_IMAGES = "ASSIGN_DAYTIME_ADVICE_IMAGES";
export const ASSIGN_DAYTIME_ADVICE_TIMEOUT_ID = "ASSIGN_DAYTIME_ADVICE_TIMEOUT_ID";
export const ASSIGN_ASSIGNED_ADVICE_TIMEOUT_ID = "ASSIGN_ASSIGNED_ADVICE_TIMEOUT_ID";
export const ASSIGN_AUTO_CALC_CHILD_AGE = "ASSIGN_AUTO_CALC_CHILD_AGE";
export const ASSIGN_DAYTIME_ADVICE_MEDIA_FILE = "ASSIGN_DAYTIME_ADVICE_MEDIA_FILE";

export const ASSIGN_ANYTIME_CONSULTATION_SHIFTS = "ASSIGN_ANYTIME_CONSULTATION_SHIFTS";
export const ASSIGN_IS_ON_ANYTIME_CONSULTATION_SHIFT = "ASSIGN_IS_ON_ANYTIME_CONSULTATION_SHIFT";
export const ASSIGN_IS_NOTICE_EXPIRATION = "ASSIGN_IS_NOTICE_EXPIRATION";

export const AC_SHIFT_UPDATE_ERROR_DETAIL = "AC_SHIFT_UPDATE_ERROR_DETAIL";

export const ASSIGN_IS_SEARCHING = "ASSIGN_IS_SEARCHING";

export const ASSIGN_CORRECTION_CONNECT_STATUS = "ASSIGN_CORRECTION_CONNECT_STATUS";
export const ASSIGN_RAW_CORRECT_NOTE = "ASSIGN_RAW_CORRECT_NOTE";
export const ASSIGN_SELECTED_NOTE_ID = "ASSIGN_SELECTED_NOTE_ID";
export const CLEAR_MARKED_NOTE_IDS = "CLEAR_MARKED_NOTE_IDS";
export const MARK_NOTE_ID = "MARK_NOTE_ID";
// export const UNMARK_NOTE_ID = "UNMARK_NOTE_ID";
export const ADD_RAW_CORRECT_NOTE = "ADD_RAW_CORRECT_NOTE";
export const ASSIGN_AUTO_CORRECTION_CHANNEL = "ASSIGN_AUTO_CORRECTION_CHANNEL";

export const ASSIGN_ANYTIME_CONSULTATION_CORRECTIONS_STATUSES = "ASSIGN_ANYTIME_CONSULTATION_CORRECTIONS_STATUSES";
export const ASSIGN_ANYTIME_CONSULTATION_CORRECTIONS_STATUS = "ASSIGN_ANYTIME_CONSULTATION_CORRECTIONS_STATUS";
export const ASSIGN_ANYTIME_CONSULTATION_CORRECTIONS_SUGGESTIONS = "ASSIGN_ANYTIME_CONSULTATION_CORRECTIONS_SUGGESTIONS";
export const UPSERT_ANYTIME_CONSULTATION_CORRECTIONS_SUGGESTION = "UPSERT_ANYTIME_CONSULTATION_CORRECTIONS_SUGGESTION";
export const ASSIGN_ANYTIME_CONSULTATION_CORRECTIONS_SELECTED_SUGGESTION_ID = "ASSIGN_ANYTIME_CONSULTATION_CORRECTIONS_SELECTED_SUGGESTION_ID";
export const ASSIGN_ANYTIME_CONSULTATION_CORRECTIONS_CHANNEL = "ASSIGN_ANYTIME_CONSULTATION_CORRECTIONS_CHANNEL";
export const ASSIGN_ANYTIME_CONSULTATION_CORRECTIONS_HAS_CONNECTED_ONCE = "ASSIGN_ANYTIME_CONSULTATION_CORRECTIONS_HAS_CONNECTED_ONCE";
export const ASSIGN_ANYTIME_CONSULTATION_CORRECTIONS_THINKING_PROGRESS = "ASSIGN_ANYTIME_CONSULTATION_CORRECTIONS_THINKING_PROGRESS";
export const CLEAR_ANYTIME_CONSULTATION_CORRECTIONS_THINKING_PROGRESS = "CLEAR_ANYTIME_CONSULTATION_CORRECTIONS_THINKING_PROGRESS";
export const ADD_IGNORED_STATIC_CHECK_QUOTE = "ADD_IGNORED_STATIC_CHECK_QUOTE";
export const MARK_EVER_TRIGGERED_STATIC_CHECK_RULES = "MARK_EVER_TRIGGERED_STATIC_CHECK_RULES";
export const RESET_ANYTIME_CONSULTATION_CORRECTIONS_STATE = "RESET_ANYTIME_CONSULTATION_CORRECTIONS_STATE";

export const ASSIGN_SIDEBAR_TAB_ID = "ASSIGN_SIDEBAR_TAB_ID";
export const ASSIGN_SIDEBAR_WIDTH_RANK = "ASSIGN_SIDEBAR_WIDTH_RANK";
export const ASSIGN_SEARCH_CONDITION_DIALOG = "ASSIGN_SEARCH_CONDITION_DIALOG";
export const ASSIGN_OPTION_DIALOG = "ASSIGN_OPTION_DIALOG";
export const ASSIGN_HAS_ONCE_SEARCHED = "ASSIGN_HAS_ONCE_SEARCHED";
export const ASSIGN_SELECT_TAB_ID = "ASSIGN_SELECT_TAB_ID";
export const RESET_SIDEBAR_STATE = "RESET_SIDEBAR_STATE";
export const OPEN_SIDEBAR = "OPEN_SIDEBAR";
export const ASSIGN_DAYTIME_SIDEBAR_WIDTH_RANK_FOR_USER = "ASSIGN_DAYTIME_SIDEBAR_WIDTH_RANK_FOR_USER";